/* @flow */
import Button from 'components/Button.jsx';
import ClipboardTrigger from 'components/ClipboardTrigger.jsx';
import Container from 'components/Container.jsx';
import React, { Component, PropTypes } from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/ActivityTransactionsTableNux.scss';

class ActivityTransactionsTableNux extends Component {
  static propTypes = {
    isFree: PropTypes.bool.isRequired,
    isClosed: PropTypes.bool.isRequired,
    activityURL: PropTypes.string.isRequired,
  }

  showCopyToast() {
    ToastActions.showSuccessToast(
      'The URL has been copied to your clipboard'
    );
  }

  renderOpenNux() {
    const subText = this.props.isFree ?
      'This activity is free, transactions do not apply to free activities.' :
      `Collected funds, deposits, and refunds will appear here.
      In the meantime, you can share this activity with your class.`;

    const title = this.props.isFree ?
      'No transactions' :
      'No transactions yet';

    return (
      <Container size="xsmall">
        <TitleHeader title={title} subtext={subText} />
        {!this.props.isFree &&
          <ClipboardTrigger
            text={this.props.activityURL}
            onCopy={this.showCopyToast}>
            <Button
              className="ActivityTransactionsTableNux-cta"
              eventElementName="ActivityTransactionsTableNux-cta">
              Get the link
            </Button>
          </ClipboardTrigger>
        }
      </Container>
    );
  }

  renderCloseNux() {
    return (
      <Container size="xsmall">
        <TitleHeader
          title="Activity closed"
          subtext="This activity is no longer available.
          To create a new activity, compose a new announcement."
        />
      </Container>
    );
  }

  render() {
    return (
      <div className="ActivityTransactionsTableNux">
        {this.props.isClosed ? this.renderCloseNux() : this.renderOpenNux()}
      </div>
    );
  }
}

export default ActivityTransactionsTableNux;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityTransactionsTableNux.jsx